import axios from '../utils/axios';

export default {
  getAll() {
    return axios.get(`${process.env.REACT_APP_ROOT_API}unidad-medida`, {
      data: {}
    });
  }
};
